import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const languageDetector = new LanguageDetector();

i18n
	.use(HttpApi) // 使用 HTTP 後端加載翻譯檔
	.use(languageDetector) // 使用內建的 cookie / querystring / navigator 偵測
	.use(initReactI18next) // 初始化React-i18next
	.init({
		supportedLngs: ["zh-TW", "zh-CN", "de", "en"], // 支持的語言列表
		fallbackLng: "zh-TW", // 無法檢測語言時的回退語言
		// 偵測順序：先看 cookie，再 querystring、再瀏覽器設定...
		detection: {
			order: [
				"cookie",
				"querystring",
				"navigator",
				"htmlTag",
				"path",
				"subdomain",
			],
			// 只把選擇的語言存到 cookie
			caches: ["cookie"],
			// cookie 參數：跨 chiuchau.com 共用
			cookieName: "i18nextLng",
			cookieDomain: ".chiuchau.com",
			cookieSecure: true,
			cookieSameSite: "Lax",
		},
		backend: {
			loadPath: "/locales/{{lng}}/translation.json", // 語言文件的加載路徑
		},
		returnObjects: true, // 允許返回對象和陣列
		interpolation: {
			escapeValue: false, // 不逃逸值，因為 React 自動逃逸
		},
	});

export default i18n;
